import React from 'react'
import Logo from '../../assets/logo.png'
import Charity from '../../assets/charity-fund.png'
import Marketing from '../../assets/marketing.png'

const StarParalax = () => {
    return (
        <div className="starparalax">
            <div id="stars"></div>
            <div id="stars2"></div>
            <div id="stars3"></div>
            <div id="title">
                <div className="container">
                    <div className="row">
                        <div className="col-md-10 col-md-offset-1">
                            <div className="main-logo-cont">
                                <div className="ring-container"
                                    data-aos="zoom-in"
                                    data-aos-delay="30"
                                    data-aos-duration="1000"
                                    data-aos-easing="ease-in-out-cubic"
                                >
                                    <div class="outer-ring center"></div>
                                    <div class="inner-ring center">
                                        <img src={Logo} alt="" />
                                    </div>
                                </div>
                                <div className="button-container howtobuy"
                                    data-aos="fade-up"
                                    data-aos-delay="30"
                                    data-aos-duration="1000"
                                    data-aos-easing="ease-in-out-cubic"
                                >
                                    <h1><span className="mission-text">MISSION</span>
                                        <br />
                                        #SAFEPIZZA FOOD BANK
                                    </h1>
                                    <h2>Holding $Pizza = Passive Income</h2>
                                    <a target="_blank" href="https://v1exchange.pancakeswap.finance/?outputCurrency=0x72eb1afddb5652e0f5c7b9a6cc1c3241348b16c6">Buy on PancakeSwap V1</a>
                                    <a target="_blank" href="https://tracker.safe-pizza.com/">$ Pizza Tracker</a>
                                    <h2>#FEED THE WORLD</h2>
                                </div>
                            </div>
                            <div className="token-container"
                                data-aos="fade-up"
                                data-aos-delay="30"
                                data-aos-duration="1000"
                                data-aos-easing="ease-in-out-cubic"
                            >
                                <h3>TOKEN INFO</h3>
                                <p>The Official SAFEPIZZA $PIZZA CONTRACT</p>
                                <a href="https://bscscan.com/token/0x72eb1afddb5652e0f5c7b9a6cc1c3241348b16c6">0x72eb1afddb5652e0f5c7b9a6cc1c3241348b16c6</a>
                            </div>
                            <div className="qr-container"
                                data-aos="fade-up"
                                data-aos-delay="30"
                                data-aos-duration="1000"
                                data-aos-easing="ease-in-out-cubic"
                            >
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="qr-box">
                                            <img src={Charity} alt="" />
                                            <div className="qr-text">
                                                <h2>Charity Fund QR
                                                    <br />Smart Chain BNB</h2>
                                                <p>0x6eAC588745a1103395C8D6fb2F8Ada616E3be492</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="qr-box">
                                            <img src={Marketing} alt="" />
                                            <div className="qr-text">
                                                <h2>Marketing RD / Exchange Donations QR
                                                    <br />Smart Chain BNB</h2>
                                                <p>0x837aea71b3A367cAFB5617E457ae3D5a46288875</p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="col-md-5">

                                        <div>
                                            <script src="https://widgets.coingecko.com/coingecko-coin-ticker-widget.js"></script>
                                            <coingecko-coin-ticker-widget currency="usd" coin-id="safepizza" locale="en"></coingecko-coin-ticker-widget>
                                        </div>
                                        <div className="holders">
                                            <h4>Holders</h4>
                                            <h3>2,372,618</h3>
                                        </div>
                                        <div className="holders">
                                            <h4>Market Cap</h4>
                                            <h3>$2,255,001,316.21</h3>
                                        </div>
                                        <div className="holders">
                                            <h4>Current Price</h4>
                                            <h3>0.000003879</h3>
                                        </div>
                                        <div className="holders">
                                            <h4>Supply</h4>
                                            <h3>581,335,735,446,765</h3>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StarParalax
